export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "To add team members, you must first save form.",
        "Administracja": "Administration",
        "Adres": "Address",
        "Adres serwera katalogowego.": "Directory server address.",
        "Adres, pod który panel wysyła powiadomienia.": "Address where panel sends notifications.",
        "Aktywna": "Active",
        "Aktywne źródła": "Active sources",
        "Aktywny": "Active",
        "Anuluj": "Cancel",
        "bez prefiksu": "without prefix",
        "Bezpieczeństwo": "Security",
        "Brak przypisanych użytkowników": "No assigned users",
        "Brak wydziału": "No department",
        "Brak wyników": "No results",
        "Brak zdefiniowanych zespołów.": "No teams defined.",
        "Bramka SMS": "SMS gateway",
        "Ciemne tło": "Dark background",
        "Ciemnoczerwona": "Dark red",
        "Ciemnozielona": "Dark green",
        "Czerwiec": "June",
        "Członkowie zespołu": "Team members",
        "Data dodania": "Date added",
        "Data opuszczenia zespołu": "Date left team",
        "Data rozpoczęcia": "Start date",
        "Data utworzenia": "Creation date",
        "Data użycia": "Date used",
        "Data wygaśnięcia": "Expiration date",
        "Data zakończenia": "End date",
        "dni": "days",
        "dnia": "day",
        "Do": "To",
        "Dodaj": "Add",
        "Dodaj dział": "Add department",
        "Dodaj token": "Add token",
        "Dodaj użytkownika": "Add user",
        "Dodaj użytkownika do zespołu": "Add user to team",
        "Dodaj użytkownika, korzystając z pola powyżej.": "Add user using field above.",
        "Dodaj zastępstwo": "Add substitution",
        "Dodaj zespół": "Add team",
        "Dodaj źródło": "Add source",
        "Dodanie działu": "Adding department",
        "Dodanie zastępstwa": "Adding substitution",
        "Dodanie zespołu": "Adding team",
        "Dodanie źródła": "Adding source",
        "Dodatkowe informacje o zastępstwie": "Additional information about substitution",
        "Dokumentacja": "Documentation",
        "Domena": "Domain",
        "Domena użytkowników źródła.": "Source user domain.",
        "Domyślna": "Default",
        "Domyślnie 389, LDAPS 636.": "389 by default, 636 for LDAPS.",
        "Dział aktywny": "Department active",
        "Dział nadrzędny": "Parent department",
        "Dział został dodany.": "Department has been added.",
        "Dział został usunięty.": "Department has been deleted.",
        "Dział został zaktualizowany.": "Department has been updated.",
        "Działy z katalogu zostaną odwzorowane jako grupy w panelu.": "Directory departments will be mapped as groups in panel.",
        "Edycja działu": "Department edit",
        "Edycja i publikacja treści": "Content editing and publishing",
        "Edycja zastępstwa": "Substitution edit",
        "Edycja zespołu": "Team edit",
        "Edycja źródła": "Source edit",
        "Edytuj": "Edit",
        "Edytuj członka grupy": "Edit group member",
        "Edytuj wpis": "Edit entry",
        "Filtr działów": "Department filter",
        "Filtr użytkowników": "User filter",
        "Filtrowanie": "Filtering",
        "Filtruj członków zespołu": "Filter team members",
        "Filtruj członków…": "Filter members…",
        "Fioletowa": "Purple",
        "Firebase": "Firebase",
        "Firebase config": "Firebase config",
        "Format, w jakim użytkownik podaje login.": "Format in which user enters login.",
        "Gotowe": "Done",
        "Grafitowa": "Graphite",
        "Grudzień": "December",
        "Hasło": "Password",
        "Hasło konta usługowego.": "Service account password.",
        "Host": "Host",
        "Identyfikator nadawcy z konsoli Firebase.": "Sender ID from Firebase console.",
        "Imię i nazwisko": "First and Last Name",
        "Inspekcja": "Inspection",
        "Integracja z Firebase": "Firebase integration",
        "Integracja z Microsoft Teams": "Microsoft Teams integration",
        "Integracja z platformą SMSAPI.pl": "Integration with SMSAPI.pl platform",
        "Jasne tło": "Light background",
        "Jeśli użytkownika nie ma na liście, uzupełnij jego dane (Imię i Nazwisko) w dziale Użytkownicy.": "If user is not listed, fill in their details (First and Last Name) in Users section.",
        "Jesteś programistą?": "Are you a developer?",
        "Język": "Language",
        "Key": "Key",
        "Key pair": "Key pair",
        "Kolor drugorzędny: %0": "Secondary color: %0",
        "Kolor icon na panelu z aplikacjami: %0": "Icon color in applications panel: %0",
        "Kolor podstawowy: %0": "Primary color: %0",
        "Kolor tekstu aktywnej pozycji menu: %0": "Active menu item text color: %0",
        "Kolor tła panelu z aplikacjami: %0": "Applications panel background color: %0",
        "Kolory zostały przywrócone.": "Colors have been restored.",
        "Kolory zostały zapisane.": "Colors have been saved.",
        "Konfiguracja aplikacji web z konsoli Firebase.": "Web app configuration from Firebase console.",
        "Koniec okresu zastępstwa.": "End of substitution period.",
        "Konta użytkowników zostały przypisane do zespołu": "User accounts have been assigned to the team",
        "Konto": "Account",
        "Konto do odpytywania katalogu.": "Account for querying the directory.",
        "Konto usługowe": "Service account",
        "Kopiuj": "Copy",
        "Krótki opis zespołu": "Short team description",
        "Kto i kogo zastępuje w wybranym okresie.": "Who substitutes for whom during the selected period.",
        "Kwiecień": "April",
        "LDAPS (LDAP over SSL)": "LDAPS (LDAP over SSL)",
        "Liczba wyników": "Number of results",
        "Lider": "Leader",
        "Lipiec": "July",
        "Listopad": "November",
        "Login": "Login",
        "Luty": "February",
        "Maj": "May",
        "Maks. 11 znaków, bez polskich liter.": "Max. 11 characters, no Polish letters.",
        "Marzec": "March",
        "Microsoft Teams": "Microsoft Teams",
        "Miesiąc": "Month",
        "Moje konto": "My account",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "You have limited ability to modify this department. Inactive fields are synchronized with external database %0.",
        "Nadawca": "Sender",
        "Nazwa": "Name",
        "Nazwa działu": "Department name",
        "Nazwa na liście źródeł.": "Name in source list.",
        "Nazwa użytkownika": "Username",
        "Nazwa zespołu": "Team name",
        "Nazwa źródła": "Source name",
        "Nie": "No",
        "Nie masz dostępu do tego modułu": "You do not have access to this module",
        "Nie udało się pobrać listy działów": "Failed to retrieve department list",
        "Nie udało się pobrać listy ról": "Failed to retrieve role list",
        "Nie udało się pobrać listy wydziałów": "Failed to retrieve division list",
        "Nie udało się pobrać listy zespołów": "Failed to retrieve team list",
        "Nie udało się pobrać projektu MCP. Spróbuj ponownie.": "Failed to retrieve MCP project. Try again.",
        "Nie udało się pobrać tokenów": "Failed to retrieve tokens",
        "Nie udało się wczytać członków zespołu": "Failed to load team members",
        "Nie udało się wczytać działu": "Failed to load department",
        "Nie zdefiniowano żadnych ról.": "No roles have been defined.",
        "Nieaktywna": "Inactive",
        "nieaktywne": "inactive",
        "Nieaktywne źródło nie bierze udziału w logowaniu.": "Inactive source is not used for login.",
        "Niebieska": "Blue",
        "Nowy token dostępu": "New access token",
        "np. AD Warszawa": "e.g. Warsaw AD",
        "np. Redaktorzy": "e.g. Editors",
        "Od": "From",
        "Okres i szczegóły": "Period and details",
        "Określ indywidualne uprawnienia przypisane do zespołu.": "Specify individual privileges assigned to the team.",
        "Opcje": "Options",
        "Opcjonalna informacja wyjaśniająca zakres zastępstwa.": "Optional information explaining scope of substitution.",
        "Opcjonalnie opisz zadania lub przeznaczenie zespołu.": "Optionally describe team tasks or purpose.",
        "Opis": "Description",
        "Opis zespołu": "Team description",
        "Organizacja": "Organization",
        "Organizacja została usunięta.": "Organization has been deleted.",
        "Osoba zastępowana": "Person being substituted for",
        "Osoba zastępująca": "Substitute",
        "Osoby": "People",
        "Paleta kolorów": "Color palette",
        "Panel może przekazywać powiadomienia do wskazanego kanału. Uzupełnij dane otrzymane od administratora Microsoft Teams.": "Panel can forward notifications to a specified channel. Enter details provided by your Microsoft Teams administrator.",
        "Panel wysyła powiadomienia push przez projekt Firebase. Po zmianie danych wcześniejsze urządzenia mogą wymagać ponownej rejestracji.": "Panel sends push notifications through a Firebase project. After changing details, previously registered devices may need to be registered again.",
        "Październik": "October",
        "Pełny dostęp do systemu": "Full access to system",
        "Plik konta usługowego w formacie JSON.": "Service account file in JSON format.",
        "Pobierz projekt dla Claude Code": "Download project for Claude Code",
        "Pobierz projekt dla Codexa": "Download project for Codex",
        "Pobierz starter teraz – po zamknięciu tego widoku pełny token nie będzie ponownie dostępny.": "Download starter now – after closing this view, full token will no longer be available.",
        "Początek okresu zastępstwa.": "Start of substitution period.",
        "Podaj nazwę, która pozwoli łatwo rozpoznać zespół.": "Enter a name that makes team easy to identify.",
        "Pokaż": "Show",
        "Pokaż hasło": "Show password",
        "Pokaż token": "Show token",
        "Połącz Edito z asystentem AI": "Connect Edito to AI assistant",
        "Połączenie szyfrowane - port zwykle 636.": "Encrypted connection - port is usually 636.",
        "Połączenie z MCP — instrukcja": "MCP connection — instructions",
        "Pole \"Liczba wyników\" jest wymagane.": "\"Number of results\" field is required.",
        "Pole \"Nadawca\" jest wymagane.": "\"Sender\" field is required.",
        "Pole \"Testowy numer telefonu\" jest wymagane.": "\"Test phone number\" field is required.",
        "Pole \"Token\" jest wymagane.": "\"Token\" field is required.",
        "Popraw błędy formularza przed zapisaniem.": "Fix form errors before saving.",
        "Port": "Port",
        "Potwierdzenie rotacji tokenu": "Token rotation confirmation",
        "Potwierdzenie usunięcia": "Deletion confirmation",
        "Pozostaw puste, aby nie zmieniać.": "Leave blank to keep unchanged.",
        "Pozostaw puste, aby utworzyć token bezterminowy. Maksymalny okres ważności wynosi 365 dni.": "Leave blank to create a token with no expiration. Maximum validity period is 365 days.",
        "Predefiniowane tła panelu z aplikacjami": "Predefined app panel backgrounds",
        "Predefiniowane zestawy kolorów": "Predefined color sets",
        "Projekt został pobrany. Rozpakuj go, utwórz nowy projekt w wybranym programie i wskaż rozpakowany folder.": "Project has been downloaded. Unpack it, create a new project in chosen program, and select unpacked folder.",
        "Przetestuj ustawienia SMS": "Test SMS settings",
        "Przykład: domena\\użytkownik": "Example: domain\\username",
        "Przykład: użytkownik": "Example: username",
        "Przykład: użytkownik@domena": "Example: username@domain",
        "Przypisanie do zespołu": "Team assignment",
        "Przywróć domyślne": "Restore defaults",
        "Publiczny klucz VAPID aplikacji web.": "Public VAPID key for web app.",
        "Puste pole oznacza wartość domyślną: (&(objectClass=organizationalUnit)).": "Blank field means default value: (&(objectClass=organizationalUnit)).",
        "Puste pole oznacza wartość domyślną: (&(objectClass=user)).": "Blank field means default value: (&(objectClass=user)).",
        "Rok": "Year",
        "Role i uprawnienia": "Roles and privileges",
        "Role zespołu": "Team roles",
        "Root": "Root",
        "Rotuj": "Rotate",
        "Sekcje użytkownika": "User sections",
        "SenderId": "SenderId",
        "Serwer": "Server",
        "Sierpień": "August",
        "Skonfiguruj połączenie standardowo w repozytorium – zarówno dla Codexa, jak i Claude Code użyj lokalnego pliku": "Configure the connection as usual in the repository – use a local file for both Codex and Claude Code",
        "Skopiowano": "Copied",
        "Spróbuj ponownie": "Try again",
        "Strona główna": "Home page",
        "Styczeń": "January",
        "Synchronizacja": "Synchronization",
        "System": "System",
        "Szukaj po nazwie…": "Search by name…",
        "Ta opcja jest przeznaczona dla redaktorów i użytkowników nietechnicznych. Wybierz program, z którego korzystasz.": "This option is intended for editors and non-technical users. Select the program you use.",
        "Tak": "Yes",
        "Testowy numer telefonu": "Test phone number",
        "Token": "Token",
        "Token OAuth z panelu SMSAPI. Przechowujemy go zaszyfrowany.": "OAuth token from SMSAPI dashboard. We store it encrypted.",
        "Token przechowuj wyłącznie w tym ignorowanym przez Git pliku.": "Store the token only in this Git-ignored file.",
        "Token utworzony": "Token created",
        "Token został usunięty.": "Token has been removed.",
        "Token został zrotowany.": "Token has been rotated.",
        "Tokeny": "Tokens",
        "Tokeny dostępu": "Access tokens",
        "Tokeny zostały usunięte.": "Tokens have been removed.",
        "Twój token": "Your token",
        "Tworzenie i edycja wpisów": "Creating and editing entries",
        "Tylko liderzy": "Leaders only",
        "Typ logowania": "Login type",
        "Ukryj": "Hide",
        "Ukryj hasło": "Hide password",
        "Ukryj token": "Hide token",
        "Uprawnienia": "privileges",
        "Uprawnienia zespołu": "Team privileges",
        "Ustal początek i koniec zastępstwa. Opcjonalnie dodaj opis jego zakresu.": "Set start and end dates for substitution. Optionally add a description of its scope.",
        "Ustawienia": "Settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "delete",
        "Usuń dział": "Delete department",
        "Usuń z zespołu": "Remove from team",
        "Utwórz grupy": "Create groups",
        "Utwórz token": "Create token",
        "Uwzględnij wydziały podrzędne": "Include subdepartments",
        "Uzupełnij wymagane pola przed testem.": "Complete required fields before testing.",
        "Użytkownicy": "Users",
        "Użytkownik": "User",
        "Użytkownik dodany": "User added",
        "Użytkownik dodany do zespołu": "User added to team",
        "Użytkownik jest liderem zespołu": "User is a team leader",
        "Użytkownik nie należy do żadnego zespołu.": "User does not belong to any team.",
        "Użytkownik został dodany do zespołu.": "User has been added to team.",
        "Użytkownik został usunięty z zespołu.": "User has been removed from team.",
        "W organizacji nie ma jeszcze żadnych działów.": "There are no departments in organization yet.",
        "W zespole": "On team",
        "W zespole od %0 %1": "On team for %0 %1",
        "Wczytywanie": "Loading",
        "Węzeł startowy wyszukiwania.": "Starting node for search.",
        "Wiadomość testowa została wysłana.": "Test message has been sent.",
        "Wiadomości wychodzą przez konto SMSAPI - token wygenerujesz w panelu platformy w sekcji „Ustawienia → API”. Nazwa nadawcy musi być zatwierdzona przez operatora, inaczej SMS-y wyjdą z pola nadawcy „Info”.": "Messages are sent via SMSAPI account - you can generate a token in platform dashboard under “Settings → API”. Sender name must be approved by operator; otherwise, SMS messages are sent with sender name “Info”.",
        "Włącz, jeśli zespół jest obecnie używany.": "Enable if team is currently in use.",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wrzesień": "September",
        "Wybierz opcję": "Select an option",
        "Wybierz role określające uprawnienia zespołu.": "Select roles that define team privileges.",
        "Wybierz użytkownika…": "Select a user…",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "Select users you want to perform actions for",
        "Wydział": "Department",
        "Wydział organizacji, do którego przypisany jest użytkownik.": "Organization department the user is assigned to.",
        "wygasł": "expired",
        "Wypełnij, jeśli połączenie wymaga autoryzacji.": "Fill in if connection requires authentication.",
        "Wyślemy jednego SMS-a testowego na podany numer - koszt zgodnie z cennikiem operatora.": "We’ll send one test SMS to the provided number - cost is based on operator’s price list.",
        "Zablokowany": "Blocked",
        "Zacznij pisać, aby wyszukać użytkownika…": "Start typing to search for a user…",
        "Zamknij": "Close",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zastępstwa": "Substitutions",
        "Zastępstwo wygasło.": "Substitution has expired.",
        "Zastępstwo wygaśnie za 10 minut.": "Substitution expires in 10 minutes.",
        "Zastępstwo wygaśnie za 5 minut.": "Substitution expires in 5 minutes.",
        "Zastępstwo wygaśnie za minutę.": "Substitution expires in one minute.",
        "Zastępstwo zostało dodane.": "Substitution has been added.",
        "Zastępstwo zostało usunięte.": "Substitution has been removed.",
        "Zastępstwo zostało zaktualizowane.": "Substitution has been updated.",
        "Zastępuje": "Substitutes for",
        "Zastępuje osobę": "Substitutes for person",
        "Zawiera": "Contains",
        "Zaznacz pole obok, aby ustawić lub zmienić hasło.": "Check box next to it to set or change password.",
        "Zespół": "Team",
        "Zespół aktywny": "Active team",
        "Zespół został dodany.": "Team has been added.",
        "Zespół został usunięty.": "Team has been removed.",
        "Zespół został zaktualizowany.": "Team has been updated.",
        "Zespoły": "Teams",
        "Zmień filtrowanie, aby zobaczyć członków zespołu.": "Change filters to see team members.",
        "Zmień hasło": "Change password",
        "Źródła LDAP": "LDAP sources",
        "Źródło aktywne": "Source active",
        "Źródło LDAP zostało dodane.": "LDAP source has been added.",
        "Źródło LDAP zostało zaktualizowane.": "LDAP source has been updated.",
        "Źródło zostało usunięte.": "Source has been deleted."
    }
};
